import { createApp } from 'vue'
import OhmCalculator from './OhmCalculator.vue'
import './assets/global.css'

createApp(OhmCalculator).mount('#ohm')
